'use client';

import { ReactNode } from 'react';
import { useTheme } from '@/hooks/useTheme';

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  useTheme(); // This hook handles applying colors to CSS
  
  return <>{children}</>;
};
